import { SET_LOADING, SET_PERFIL } from './mutation-types'
import objectHelper from '@/helpers/object.helper'

export default {
    [SET_LOADING](state, payload) {
        state.loading = payload;
    },
    [SET_PERFIL](state, payload) {
        state.perfil = objectHelper.copy(payload)
    }
}